import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

import { PAGES } from '~/constants';
import { isValidUserSession } from '~/slices/auth';

const PrivateRoute = ({ children }) => {
    const dispatch = useDispatch();
    const [isAuthorized, setIsAuthorized] = useState(null);
    const { search } = useLocation();
    const location = useLocation();

    useEffect(() => {
        async function validateUserSession() {
            const { payload } = await dispatch(isValidUserSession());
            setIsAuthorized(payload);
        }

        validateUserSession();
    }, [location]);

    if (isAuthorized === null) {
        return null;
    }

    if (isAuthorized === false) {
        return <Navigate to={`${PAGES.Login}${search}`} replace />;
    }

    return <>{children}</>;
};

export default PrivateRoute;
